// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OfficeAttendanceSchedule  {
    _originalTypeClassName = "Loom.BO.OfficeAttendanceSchedule";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OfficeAttendanceSchedule.translate = translateService;
}
this.OfficeAttendanceEvenWeeks = [];
this.OfficeAttendanceOddWeeks = [];
this.Id = null;
this.StartDate = null;
this.EndDate = null;
this.IsActive = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
StartDate:any;
EndDate:any;
IsActive:any;
Facility:any;
OfficeAttendanceEvenWeeks:any;
OfficeAttendanceOddWeeks:any;
static setFacility = ($this, value) => {
var oldValue = $this.Facility;
$this.Facility = value;
if (value != null) {
if (oldValue != null) {
Domain.Facility.removeAttendanceSchedules(oldValue, $this);
}
Domain.Facility.addAttendanceSchedules(value, $this);
}
}
static setOfficeAttendanceEvenWeeks = ($this, items) => {
                if (items == null) items = [];
                if ($this.OfficeAttendanceEvenWeeks == null) $this.OfficeAttendanceEvenWeeks = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OfficeAttendanceEvenWeeks.length > 0) {
                    Domain.OfficeAttendanceSchedule.removeOfficeAttendanceEvenWeeks($this, $this.OfficeAttendanceEvenWeeks[0]);
                }

                Domain.OfficeAttendanceSchedule.addManyOfficeAttendanceEvenWeeks($this, copyItems);
            }
static addManyOfficeAttendanceEvenWeeks = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OfficeAttendanceSchedule.addOfficeAttendanceEvenWeeks($this, items[i]);
                }
            }
static addOfficeAttendanceEvenWeeks = ($this, item) => {
                if ($this.OfficeAttendanceEvenWeeks == null) $this.OfficeAttendanceEvenWeeks = [];
                if (item == null || $this.OfficeAttendanceEvenWeeks.indexOf(item) > -1) return;
                $this.OfficeAttendanceEvenWeeks.push(item);
if (item.OfficeAttendanceScheduleForEven != $this) {
Domain.OfficeAttendance.setOfficeAttendanceScheduleForEven(item, $this);
}
}
static addRangeOfficeAttendanceEvenWeeks = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OfficeAttendanceSchedule.addOfficeAttendanceEvenWeeks($this, item));
            }
static removeOfficeAttendanceEvenWeeks = ($this, item) => {
                if ($this == null || $this.OfficeAttendanceEvenWeeks == null || $this.OfficeAttendanceEvenWeeks.indexOf(item) === -1) return;
                var _index = $this.OfficeAttendanceEvenWeeks.indexOf(item);
                $this.OfficeAttendanceEvenWeeks.splice(_index, 1);
item.OfficeAttendanceScheduleForEven = null;
}
static clearOfficeAttendanceEvenWeeks = ($this) => { $this.OfficeAttendanceEvenWeeks = null; }
static setOfficeAttendanceOddWeeks = ($this, items) => {
                if (items == null) items = [];
                if ($this.OfficeAttendanceOddWeeks == null) $this.OfficeAttendanceOddWeeks = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OfficeAttendanceOddWeeks.length > 0) {
                    Domain.OfficeAttendanceSchedule.removeOfficeAttendanceOddWeeks($this, $this.OfficeAttendanceOddWeeks[0]);
                }

                Domain.OfficeAttendanceSchedule.addManyOfficeAttendanceOddWeeks($this, copyItems);
            }
static addManyOfficeAttendanceOddWeeks = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OfficeAttendanceSchedule.addOfficeAttendanceOddWeeks($this, items[i]);
                }
            }
static addOfficeAttendanceOddWeeks = ($this, item) => {
                if ($this.OfficeAttendanceOddWeeks == null) $this.OfficeAttendanceOddWeeks = [];
                if (item == null || $this.OfficeAttendanceOddWeeks.indexOf(item) > -1) return;
                $this.OfficeAttendanceOddWeeks.push(item);
if (item.OfficeAttendanceScheduleForOdd != $this) {
Domain.OfficeAttendance.setOfficeAttendanceScheduleForOdd(item, $this);
}
}
static addRangeOfficeAttendanceOddWeeks = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OfficeAttendanceSchedule.addOfficeAttendanceOddWeeks($this, item));
            }
static removeOfficeAttendanceOddWeeks = ($this, item) => {
                if ($this == null || $this.OfficeAttendanceOddWeeks == null || $this.OfficeAttendanceOddWeeks.indexOf(item) === -1) return;
                var _index = $this.OfficeAttendanceOddWeeks.indexOf(item);
                $this.OfficeAttendanceOddWeeks.splice(_index, 1);
item.OfficeAttendanceScheduleForOdd = null;
}
static clearOfficeAttendanceOddWeeks = ($this) => { $this.OfficeAttendanceOddWeeks = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}